module.exports = __webpack_public_path__ + "static/media/rm.a441f869.png";